<template>
    <UPS></UPS>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const UPS = defineAsyncComponent(() =>
    import("../../components/Logistics/UPS_FEDEX.vue")
);
export default {
    name: "Logistics_UPS",
    components: { UPS, AuthLayout },
};
</script>
